import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getMccList = () => get(url.MCC_DEF_GET)
export const getRangeIsoList = () => get(url.MCC_ISO_RANGE_GET)
export const getMccMastercardServiceCategoryDefList = () => get(url.MCC_MASTERCARD_SERVİCE_CATEGORY_DEF_GET)
export const getMccVisaServiceCategoryDefList = () => get(url.MCC_VISA_SERVICE_CATEGORY_DEF_GET)
export const getMccNationalSwitchCategoryDefList = () => get(url.MCC_NATIONAL_SWITCH_CATEGORY_DEF_GET)
export const getMccGeographyTypeDefList = () => get(url.MCC_GEOGRAPHY_TYPE_DEF_GET)

export const addMccDef = record => post(url.MCC_DEF_INSERT, record)
export const updateMccDef = record => put(url.MCC_DEF_UPDATE, record)
export const deleteMccDef = guid => del(url.MCC_DEF_DELETE, { params: { guid } })